<template>
  <el-input-number class="input" :controls="false"  :min="parseInt(limit_min)"  :value='result' @change="input" @blur="listenBlur" >
	</el-input-number>

</template>

<script>
export default {
	data() {
		return {
		}
	},
	props:{
		value: {
			required: true,
			default() {
				return '';
			}
		},
		row: {
			type: Object,
			default() {
				return {};
			}
		},
		limit_min: {
			default() {
				return null;
			}
		},
		onBlur: {
			type: Function,
			default() {
				return null;
			}
		}
	},
	computed:{
		result(){

			return (this.value*100).toFixed(0);
		}
	},
	methods:{
		input(v){
			// if (this.limit_min && this.value < this.limit_min) {
			// 	this.$emit('input',0);
			// 	return;
			// }
			this.$emit('input',(v/100).toFixed(2));
		},
		async listenBlur() {
			await this.onBlur(this.row);
		}
	}
}
</script>

<style scoped>
.input{
	width:100px;
}
</style>
